import Vue from 'vue'
import Router from 'vue-router'
import StartPage from '@/components/StartPage'
import AllaOvningar from '@/components/alla-ovningar'
import Ovningsblad from '@/components/ovningsblad'
import Grammatikbok from '@/components/grammatikbok'
//import Hashtag from '@/components/hashtag'


Vue.use(Router)

export default new Router({
    mode: 'history',
  routes: [
    {
        path: '/',
        name: 'StartPage',
        component: StartPage,


    },
/*    {
        path: '/#',
        name: 'Hashtag',
        component: Hashtag,

    },*/
    {
        path: '/none0',
        rubrik: 'Verb',
        synligVid: 1
    },
    {
        path: '/ovningar/presens-av-svaga-verb',
        name: 'PresensAvSvagaVerb',
        component: Ovningsblad,
        props: {
            grammatik: "Testgrammatik",
            title: "Presens av svaga verb",
            avsnitt: "PresensAvSvagaVerb",
            grambok: true,
            //nasta: "Presens av starka verb >",
            //nastaLank: "/ovningar/presens-av-starka-verb",
            synligVid:1,
            svartVid:1,
            uppgifter: [
                ["Vad gör du idag?", "Was machst du heute?", ["","","","heute"]],
                ["Jag spelar fotboll.", "Ich spiele Fußball.",["","","Fußball"]],
                ["Kommer ni också, barn?", "Kommt ihr auch, Kinder?",["","","","das Kind -er"]],
                ["Vi kommer senare.", "Wir kommen später.",["","","später"]],
                ["Barnen gör läxor.", "Die Kinder machen Hausaufgaben.",["das Kind -er","","die Hausaufgabe -n"]],
                ["Vart går ni, doktor Meier?", "Wohin gehen Sie, Doktor Meier?",[]],
                ["Hittar du din bok?", "Findest du dein Buch?",["","","","das Buch -er+"]],
                ["Badar ni ofta, barn?", "Badet ihr oft, Kinder?",["","","","das Kind -er"]],
                ["Han dricker alltid mycket.", "Er trinkt immer viel.",["","","immer","viel"]],
                ["Bettina bor i Berlin.", "Bettina wohnt in Berlin.",[]],
                ["Hon sjunger bra.", "Sie singt gut.",[]],
            ],
        }
    },
    {
        path: '/ovningar/presens-av-starka-verb',
        name: 'PresensAvStarkaVerb',
        component: Ovningsblad,
        props: {
            grammatik: "Testgrammatik",
            title: "Presens av starka verb",
            avsnitt: "PresensAvStarkaVerb",
            grambok: true,
            //foregaende: "< Presens av svaga verb",
            //foregaendeLank :"/ovningar/svaga-verb-i-presens",
            //nasta: "Presens av sein >",
            //nastaLank: "/ovningar/presens-av-sein",
            synligVid:1,
            svartVid:1,

            uppgifter: [
                ["Pratar du tyska?", "Sprichst du Deutsch?",["","","Deutsch"]],
                ["Ja, naturligtvis pratar jag tyska.", "Ja, natürlich spreche ich Deutsch.",["", "natürlich","","","Deutsch"]],
                ["Jag åker hem. Min bror åker också hem.", "Ich fahre nach Hause. Mein Bruder fährt auch nach Hause.",["","","nach Hause","","der Bruder -+","","","nach Hause"]],
                ["Du springer verkligen snabbt.", "Du läufst wirklich schnell.",["","laufen","wirklich","schnell"]],
                ["De flesta springer långsamt.", "Die meisten laufen langsam.",[]],
                ["Vad läser du?", "Was liest du?",[]],
                ["Jag läser bara tidningen.", "Ich lese nur die Zeitung.",["","","","die Zeitung -en"]],
                ["Läser ni många böcker, barn?", "Lest ihr viele Bücher, Kinder?",["","","","das Buch -er+"]],

                ["Det ser du väl?", "Das siehst du wohl?",["","","","wohl"]]
            ],
        }
    },
    {
        path: '/ovningar/presens-av-sein',
        name: 'PresensAvSein',
        component: Ovningsblad,
        props: {
            grammatik: "Testgrammatik",
            title: 'Presens av sein',
            avsnitt: "PresensAvSein",
            grambok: true,
            //foregaende: "< Presens av starka verb",
            //foregaendeLank :"/ovningar/presens-av-starka-verb",
            //nasta: "Presens av haben >",
            //nastaLank: "/ovningar/presens-av-haben",
            synligVid:1,
            svartVid:1,

            uppgifter: [
                ["Jag är tretton.", "Ich bin dreizehn.",["","","dreizehn"]],
                ["Min syster är äldre.", "Meine Schwester ist älter.",["","die Schwester -n","","älter"]],
                ["Hon är sexton är gammal.", "Sie ist sechzehn Jahre alt.",["","","sechzehn"]],
                ["Vi är i Malmö.", "Wir sind in Malmö.",[]],
                ["Är du hemma?", "Bist du zu Hause?",["","","zu Hause"]],
                ["Är ni klara, barn?", "Seid ihr fertig, Kinder?",["","","fertig"]],
                ["Är Ni klar, doktor Meier?", "Sind Sie fertig, Doktor Meier?",["","","fertig","Doktor"]],
                ["Var är mina saker?", "Wo sind meine Sachen?",["","","","die Sache -n"]],
                ["De är här.", "Sie sind hier.",[]],
                ["Min bror och jag är fotbollsfans.", "Mein Bruder und ich sind Fußballfans.",["","der Bruder -","","","","der Fußballfan -s"]],
                ["Min familj är mycket kulturell.", "Meine Familie ist sehr kulturell.",["","die Familie -n","","sehr","kulturell"]],
                ["Huset är stort.", "Das Haus ist groß.",["das Haus -er+"]],
                ["Det är också ganska gammalt.", "Es ist auch ziemlich alt.",["","","","ziemlich"]],
                ["Herr Müller är professor.", "Herr Müller ist Professor.",["","","","der Professor -en"]],
            ],
        }
    },
    {
        path: '/ovningar/presens-av-haben',
        name: 'PresensAvHaben',
        component: Ovningsblad,
        props: {
            grammatik: "Testgrammatik",
            title: 'Presens av haben',
            avsnitt: "PresensAvHaben",
            grambok: true,
            //foregaende: "< Presens av sein",
            //foregaendeLank :"/ovningar/presens-av-sein",
            synligVid:1,
            svartVid:1,

            uppgifter: [
                ["Jag har en katt.", "Ich habe eine Katze.",["","","","die Katze -n"]],
                ["Har du ett djur?", "Hast du ein Tier?",["","","","das Tier -e"]],
                ["Nej, men min syster har en häst.", "Nein, aber meine Schwester hat ein Pferd.",["","","","die Schwester -n","","","das Pferd -e"]],
                ["Vi har inga planer.", "Wir haben keine Pläne.",["","","","der Plan -e+"]],
                ["Har ni något för er idag?", "Habt ihr heute etwas vor?",["","","","etwas vor haben","etwas vor haben","heute"]],
                ["Barnen har många leksaker.", "Die Kinder haben viele Spielzeuge.",["das Kind -er","","","das Spielzeug -e"]],
            ],
        }
    },


    {
        path: '/ovningar/none1',
        radbryt: true,
    },

    {
        path: '/ovningar/perfekt-svaga-verb',
        name: 'PerfektAvSvagVerb',
        component: Ovningsblad,
        props: {
            grammatik: "Testgrammatik",
            title: "Perfekt av svaga verb",
            avsnitt: "PerfektAvSvagaVerb",
            grambok: true,
            //nasta: "Perfekt av starka verb >",
            //nastaLank: "/perfekt-starka-verb",
            synligVid:2,
            svartVid:2,
            uppgifter: [
                ["Jag har köpt ett hus.", "Ich habe ein Haus gekauft.",["","","","","das Haus -er+"]],
                ["Igår har vi badat.", "Gestern haben wir gebadet.",["gestern"]],
                ["Hon har spelat piano.", "Sie hat Klavier gespielt.",["","","","das Klavier -e"]],
                ["Vi har haft kul.", "Wir haben Spaß gehabt.",["","","","Spaß"]],
                ["Har du pratat i telefon med mormor?", "Hast du mit Oma telefoniert?",["","","telefonieren","telefonieren","telefonieren","","die Oma -s"]],
                ["Han har reparerat sin cykel.", "Er hat sein Fahrrad repariert.",["","","","","das Fahrrad -er+"]],
                ["Jag har bott i Berlin.", "Ich habe in Berlin gewohnt.",[]],
                ["Har de också bott i Tyskland?", "Haben sie auch in Deutschland gewohnt?",["","","","","","Deutschland"]],
                ["De har bott utomlands.", "Sie haben im Ausland gewohnt.",["","","","im Ausland"]],
                ["Idag har jag lärt mig mycket.", "Heute habe ich vieles gelernt.",["heute","","","","","vieles"]],
            ],
        }
    },
    {
        path: '/ovningar/perfekt-starka-verb',
        name: 'PerfektAvStarkaVerb',
        component: Ovningsblad,
        props: {
            grammatik: "Testgrammatik",
            title: "Perfekt av starka verb",
            avsnitt: "PerfektAvStarkaVerb",
            grambok: true,
            //foregaende: "< Perfekt av svaga verb",
            //foregaendeLank :"/perfekt-svaga-verb",
            //nasta: "Perfekt med sein som hjälpverb >",
            synligVid:2,
            svartVid:2,
            //nastaLank: "/perfekt-med-sein-som-hjälpverb",
            uppgifter: [
                ["Vi har pratat länge.", "Wir haben lange gesprochen.",[]],
                ["Vad har du ätit idag?", "Was hast du heute gegessen?",[]],
                ["Christine Nöstlinger har skrivit många böcker.", "Christine Nöstlinger hat viele Bücher geschrieben.",["","","","","","das Buch -er+"]],
                ["Har ni hittat era leksaker?", "Habt ihr euere Spielzeuge gefunden?",["","","","","das Spielzeug -e"]],
                ["De har inte sett någonting.", "Sie haben nichts gesehen.",[]],
                ["Jag har träffat mina vänner.", "Ich habe meine Freunde getroffen.",[]],
                ["Han har sovit till klockan 10.", "Er hat bis 10 Uhr geschlafen.",[]],
                ["Har Ni läst min historia, herr Lärare?", "Haben Sie meine Geschichte gelesen, Herr Lehrer?",["","","","","die Geschichte -n"]],
                ["Hon har haft på sig (burit) en klänning varje dag.", "Sie hat jeden Tag ein Kleid getragen.",["","","","","","","","das Kleid -er","jeden Tag","jeden Tag"]],
                ["Har du druckit kaffe i morse?", "Hast du heute Morgen Kaffee getrunken?",["","","","Kaffee", "heute Morgen", "heute Morgen"]],
                ["Jag har alltid tvättat mina kläder själv.", "Ich habe immer selbst meine Kleider gewaschen.",["","","","","","Kleider","selbst"]],
                ["Den gamle mannen har glömt, att han redan har tagit sina mediciner.", "Der alte Mann hat vergessen, dass er seine Medikamente schon genommen hat.",["","","","","","","","","","","","Medikamente (pl)"]],
            ],
        }
    },
    {
        path: '/ovningar/perfekt-med-sein-som-hjalpverb',
        name: 'PerfektMedSeinSomHjalpverb',
        component: Ovningsblad,
        props: {
            grammatik: "Testgrammatik",
            title: "Perfekt med sein som hjälpverb",
            avsnitt: "PerfektMedSeinSomHjalpverb",
            grambok: true,
            //foregaende: "< Perfekt av starka verb",
            //foregaendeLank :"/perfekt-starka-verb",
            //nasta: "Perfekt, blandade övningar >",
            //nastaLank: "/perfekt-blandade-övningar",
            synligVid:2,
            svartVid:2,

            uppgifter: [
                ["Har du varit i Tyskland?","Bist du in Deutschland gewesen?",["","","","","Deutschland"]],
                ["Min häst har hoppat högt.","Mein Pferd ist hoch gesprungen.",["","das Pferd -e"]],
                ["Hur länge har ni stannat i Norge?","Wie lange seid ihr in Norwegen geblieben?",[]],
                ["Han har flugit till USA.","Er ist in die USA geflogen.",["","","","in die USA","in die USA"]],
                ["Vart har Ni rest, fru Schneider?","Wohin sind Sie gereist, Frau Schneider?",[]],
                ["Snön har smält.","Der Schnee ist geschmolzen.",["der Schnee"]],
                ["Vi har blivit väldigt glada.","Wir sind sehr froh geworden.",["","","","sehr","froh"]],
                ["Hon har gått till skolan.","Sie ist zur Schule gegangen.",["","","","zur Schule","zur Schule"]],
                ["I kriget har många dött.","Im Krieg sind viele gestorben.",["", "der Krieg -e","","viele"]],
                ["Hur snabbt har ni sprungit?","Wie schnell seid ihr gelaufen?",["","","","","laufen"]],
                ["Har alla kommit?","Sind alle gekommen?",[]],
                ["Ja, men några har redan åkt.","Ja, aber einige sind schon gefahren.",["","","einige","","schon"]],
            ],
        }
    },
    {
        path: '/ovningar/perfekt-blandade-ovningar',
        name: 'Perfekt, blandade övningar',
        component: Ovningsblad,
        props: {
            grammatik: '/ovningar/perfekt-blandade-övningar.vue',
            title: 'Perfekt blandade övningar',
            avsnitt: "PerfektBlandadeOvningar",
            grambok: false,
            //foregaende: "< Perfekt med sein som hjälpverb",
            //foregaendeLank :"/perfekt-med-sein-som-hjälpverb",
            synligVid:2,
            svartVid:2,

            uppgifter: [
                ["Jag har köpt en blomma.", "Ich habe eine Blume gekauft.",["","","","","die Blume -n"]],
                ["De har bott i Hamburg.", "Sie haben in Hamburg gewohnt.",[]],
                ["Har ni arbetat flitigt, elever?", "Habt ihr fleißig gearbeitet, Schüler?",["","","","fleißig","der Schüler -"]],
                ["Har du hittat något intressant?", "Hast du etwas Interessantes gefunden?",["","","","etwas Interessantes","etwas Interessantes"]],
                ["Var har ni varit?", "Wo seid ihr gewesen?",[]],
                ["Vi har fått ett brev.", "Wir haben einen Brief bekommen.",["","","","","der Brief -e"]],
                ["Hon har gått till stan.", "Sie ist in die Stadt gegangen.",["","","in die Stadt gehen","in die Stadt gehen","in die Stadt gehen"]],
                ["Vart har Ni rest på semestern, herr Braun?", "Wohin sind Sie im Urlaub gereist, Herr Braun?",["","","","","im Urlaub","im Urlaub"]],
                ["Hur länge har Ni stannat där?", "Wie lange sind Sie dort geblieben?",[]],
                ["Har du hört något?", "Hast du etwas gehört?",[]],
                ["Nej, men jag har sett något konstig.", "Nein, aber ich habe etwas komisches gesehen.",["","","","","","etwas komisches","etwas komisches"]],
                ["Har du blivit knäpp?", "Bist du verrückt geworden?",["","","","verrückt"]],
            ],
        }
    },
    {
        path: '/ovningar/none2',
        radbryt: true,
    },

    {
        path: '/ovningar/modala-hjalpverb',
        name: 'ModalaHjalpverb',
        component: Ovningsblad,
        props: {
            grammatik: './grammatik/modala-hjalpverb.vue',
            title: "Modala hjälpverb",
            avsnitt: "ModalaHjalpverb",
            grambok: true,
            synligVid:1,
            svartVid:1,

            uppgifter: [
                ["Kan vi komma imorgon?", "Können wir morgen kommen?",["","","","morgen"]],
                ["Jag vill inte gå till skolan.", "Ich will nicht zur Schule gehen.",["","","","","zur Schule","zur Schule"]],
                ["Vi får inte köpa öl.", "Wir dürfen nicht Bier kaufen.",["","","","","das Bier -e"]],
                ["Gillar du din katt?", "Magst du deine Katze?",["","","","die Katze -n"]],
                ["Vi måste skynda oss!", "Wir müssen uns beeilen!",["","","sich beeilen","sich beeilen"]],
                ["Kan Peter spela fotboll?", "Kann Peter Fußball spielen?",["","","","Fußball"]],
                ["Ni skall inte gå utan skor.", "Ihr sollt nicht ohne Schuhe gehen.",["","","","","ohne","der Schuh -e"]],
                ["Får du följa med, eller måste du stanna hemma?", "Darfst du mitkommen, oder musst du zu Hause bleiben?",["","","mitkommen","mitkommen","","","","","zu Hause"]],
                ["Vet du egentligen, vad det där är?", "Weißt du eigentlich, was das ist?",["","","eigentlich"]],
                ["Ni vet säkert inget.", "Ihr wisst sicher nichts.",["","","sicher","nichts"]],
                ["Vi vill ha glass.", "Wir wollen Eis haben.",["","","","das Eis"]]
            ],
        }
    },
    {
        path: '/ovningar/infinitiv-vs-perfektparticip',
        name: 'InfinitivPerfekt',
        component: Ovningsblad,
        props: {
            grammatik: "Testgrammatik",
            title: 'Infinitiv vs perfektparticip',
            avsnitt: "InfinitivPerfekt",
            grambok: true,
            synligVid:3,
            svartVid:3,

            uppgifter: [
                ["Har du spelat fiol?", "Hast du Geige gespielt?",["", "", "", "die Geige -n"]],
                ["Kan du spela fiol?", "Kannst du Geige spielen?",["", "", "", "die Geige -n"]],
                ["Ni måste åka till Berlin, flickor.", "Ihr müsst nach Berlin fahren, Mädchen.",[]],
                ["Vi har redan åkt till Berlin.", "Wir sind schon nach Berlin gefahren.",["","","schon"]],
                ["Du måste komma!", "Du musst kommen!",[]],
                ["Har du väntat?", "Hast du gewartet?",[]],
                ["De har kommit.", "Sie sind gekommen.",[]],
                ["Jag har glömt mina nycklar.", "Ich habe meine Schlüssel vergessen.",["","","","","der Schlüssel -"]],
                ["Dem kan man ofta glömma.", "Sie kann man oft vergessen.",["","","","oft", "vergessen"]]
            ],
        }
    },

    {
        path: '/ovningar/none3',
        radbryt: true,
    },

    {
        path: '/ovningar/imperfekt-av-svaga-verb',
        name: 'ImperfektAvSvagaVerb',
        component: Ovningsblad,
        props: {
            grammatik: './grammatik/imperfekt-av-svaga-verb.vue',
            title: "Imperfekt av svaga verb",
            avsnitt: "ImperfektAvSvagaVerb",
            grambok: true,
            synligVid:3,
            svartVid:4,

            uppgifter: [
                ["Han spelade piano.", "Er spielte Klavier.",["","","das Klavier -e"]],
                ["Vi bodde på den tiden i Freiburg.", "Wir wohnten damals in Freiburg.",["","","damals","damals","damals"]],
                ["Vad gjorde du där?", "Was machtest du da?",[]],
                ["Jag arbetade hårt.", "Ich arbeitete hart.",["","","hart"]],
                ["De köpte en hund.", "Sie kauften einen Hund.",["","","","der Hund -e"]],
                ["De betalade mycket.", "Sie bezahlten viel.",[]],
                ["Barnet badade.", "Das Kind badete.",[]],
                ["Hörde ni?", "Hörtet ihr?",[]],
                ["Hon frågade kassörskan.", "Sie fragte die Verkäuferin.",["","","die Verkäuferin -nen"]],
                ["Jag försökte flera gånger.", "Ich versuchte vielmals.",["","","vielmals","vielmals"]],
            ],
        }
    },

    {
        path: '/ovningar/imperfekt-av-starka-verb',
        name: 'ImperfektAvStarkaVerb',
        component: Ovningsblad,
        props: {
            grammatik: './grammatik/imperfekt-av-starka-verb.vue',
            title: "Imperfekt av starka verb",
            avsnitt: "ImperfektAvStarkaVerb",
            grambok: true,
            synligVid:3,
            svartVid:4,

            uppgifter: [
                ["Hon läste en bok.", "Sie las ein Buch.",[]],
                ["Vi skrev många brev.", "Wir schrieben viele Briefe.",["","","","der Brief -e"]],
                ["De åt korv och drack öl.", "Sie aßen Wurst und tranken Bier.",["","","die Wurst -e+"]],
                ["Han pratade bara hela tiden.", "Er sprach nur die ganze Zeit.",["","","","die ganze Zeit","die ganze Zeit"]],
                ["Jag såg inget.", "Ich sah nichts.",[]],
                ["Hunden hittade inget.", "Der Hund fand nichts.",[]],
                ["Han tog sakerna och gick hem.", "Er nahm die Sachen und ging nach Hause.",["","","die Sache -n"]],
                ["Hon hade en klänning på sig.", "Sie trug ein Kleid.",["","","","das Kleid -er"]],
                ["Hittade Ni vad Ni sökte?", "Fanden Sie, was Sie suchten?",[]],
                ["De träffades alltid på torget.", "Sie trafen sich immer auf dem Marktplatz.",["","","","","der Marktplatz -e+"]],
            ],
        }
    },

    {
        path: '/none4',
        rubrik: 'Substantiv',
        synligVid: 1
    },
    {
        path: '/ovningar/der-ord',
        name: 'DerOrd',
        component: Ovningsblad,
        props: {
            grammatik: './grammatik/der-ord.vue',
            title: "der-ord",
            avsnitt: "DerOrd",
            grambok: true,
            synligVid:1,
            svartVid:1,
            uppgifter: [
                ["mannen männen", "der Mann die Männer", []],
                ["svensken svenskarna", "der Schwede die Schweden", []],
                ["bilen(vagnen) bilarna(vagnarna)", "der Wagen die Wagen", []],
                ["skon skorna", "der Schuh die Schuhe", []],
                ["fadern fäderna", "der Vater die Väter", []],
                ["trädet träden", "der Baum die Bäume", []],
                ["dammsugaren dammsugarna", "der Staubsauger die Staubsauger", []],
                ["platsen platserna", "der Platz die Plätze", []],
                ["vännen vännerna", "der Freund die Freunde", []],
                ["pojken pojkarna", "der Junge die Jungen", []],
                ["hunden hundarna", "der Hund die Hunde", []],
                ["fågeln fåglarna", "der Vogel die Vögel", []],
                ["datorn datorerna", "der Computer die Computers", []],


            ],
        }
    },

    {
        path: '/ovningar/das-ord',
        name: 'DasOrd',
        component: Ovningsblad,
        props: {
            grammatik: './grammatik/das-ord.vue',
            title: "das-ord",
            avsnitt: "DasOrd",
            grambok: true,
            //nasta: "Presens av starka verb >",
            //nastaLank: "/ovningar/presens-av-starka-verb",
            synligVid:1,
            svartVid:1,
            uppgifter: [

                ["barnet barnen", "das Kind die Kinder", []],
                ["landet länderna", "das Land die Länder", []],
                ["rummet rummen", "das Zimmer die Zimmer", []],
                ["djuret djuren", "das Tier die Tiere", []],
                ["bilen bilarna", "das Auto die Autos", []],
                ["cykeln cyklarna", "das Fahrrad die Fahrräder", []],
                ["huset husen", "das Haus die Häuser", []],
                ["året åren", "das Jahr die Jahre", []],
                ["elden eldarna", "das Feuer die Feuer", []],
                ["flickan flickorna", "das Mädchen die Mädchen", []],
                ["fönstret fönstren", "das Fenster die Fenster", []],


            ],
        }
    },
    {
        path: '/ovningar/die-ord',
        name: 'DieOrd',
        component: Ovningsblad,
        props: {
            grammatik: './grammatik/die-ord.vue',
            title: "die-ord",
            avsnitt: "DieOrd",
            grambok: true,
            //nasta: "Presens av starka verb >",
            //nastaLank: "/ovningar/presens-av-starka-verb",
            synligVid:1,
            svartVid:1,
            uppgifter: [
                ["kvinnan kvinnorna", "die Frau die Frauen", []],
                ["familjen familjerna", "die Familie die Familien", []],
                ["skolan skolorna", "die Schule die Schulen", []],
                ["veckan veckorna", "die Woche die Wochen", []],
                ["gatan gatorna", "die Straße die Straßen", []],
                ["vänninan vänninorna", "die Freundin die Freundinnen", []],
                ["blomman blommorna", "die Blume die Blumen", []],
                ["partiet partierna", "die Partei die Parteien", []],
                ["tidningen tidningarna", "die Zeitung die Zeitungen", []],
                ["tiden tiderna", "die Zeit die Zeiten", []],
                ["färden färderna", "die Fahrt die Fahrten", []],
                ["svenskan svenskorna", "die Schwedin die Schwedinnen", []],


            ],
        }
    },
    {
        path: '/ovningar/genus-och-plural',
        name: 'GenusOchPlural',
        component: Ovningsblad,
        props: {
            grammatik: './grammatik/genus-och-plural.vue',
            title: "Genus och plural",
            avsnitt: "GenusOchPlural",
            grambok: true,
            //nasta: "Presens av starka verb >",
            //nastaLank: "/ovningar/presens-av-starka-verb",
            synligVid:1,
            svartVid:1,
            uppgifter: [
                ["Tidningen är här.", "Die Zeitung ist hier.", []],
                ["Var är svenskarna?", "Wo sind die Schweden?", []],
                ["Djuren är glada", "Die Tiere sind froh.", ["","","froh"]],
                ["Skolan är bra.", "Die Schule ist gut.", []],
                ["Landet är vackert", "Das Land ist schön.", []],
                ["Jag känner till många länder.", "Ich kenne viele Länder.", ["", "kennen","kennen"]],
                ["Här är platsen.", "Hier ist der Platz.", []],
                ["Träden är gröna.", "Die Bäume sind grün.", ["", "", "grün"]],
                ["Cyklarna är nya.", "Die Fahrräder sind neu.", ["", "", "neu"]],
                ["Gatan är lång.", "Die Straße ist lang.", ["", "", "lang"]],
            ],
        }
    },

    {
        path: '/ovningar/none5',
        rubrik: 'Adjektiv',
        synligVid: 3
    },

    {
        path: '/ovningar/adjektiv-stark-svag-bojning',
        name: 'AdjektivStarkSvagBöjning',
        component: Ovningsblad,
        props: {
            grammatik: './grammatik/adjektiv-stark-svag-bojning.vue',
            title: "Stark och svag böjning",
            avsnitt: "AdjektivStarkSvagBöjning",
            grambok: true,
            synligVid:4,
            svartVid:5,

            uppgifter: [
                ["Har du en ny bil?", "Hast du ein neues Auto?",["", "", "", "", "das Auto -s"]],
                ["Den nya bilen är snabb.", "Das neue Auto ist schnell.",["","","das Auto -s"]],
                ["Denna gula byggnaden är vår nya skola.", "Dieses gelbe Gebäude ist unsere neue Schule.",["","","das Gebäude -"]],
                ["Tyskland är ett stort land.", "Deutschland ist ein großes Land.",["","","","","das Land -er+"]],
                ["Berlin är en stor stad.", "Berlin ist eine große Stadt.",["","","","","die Stadt -e+"]],
                ["Svart kaffe är starkt men smakar gott.", "Schwarzer Kaffee ist stark, aber schmeckt gut.",["","der Kaffee"]],
                ["Små barn är söta.", "Kleine Kinder sind süß.",[]],
                ["Men de små barnen skriker ibland.", "Aber die kleinen Kinder schreien manchmal.",["","","","","schreien"]],
                ["Mina små barn skriker aldrig.", "Meine kleinen Kinder schreien nie.",["","","","schreien"]],
                ["I vår lilla stad promenerar vi på vackra gatorna.", "In unserer kleinen Stadt gehen wir auf den schönen Straßen spazieren.",["","","","die Stadt -e+"]],
                ["Vackra hus ser man ofta.", "Schöne Häuser sieht man oft.",[]],
                ["Han hittade en intressant bok i den gamla bokhandeln.", "Er fand ein interessantes Buch im alten Buchladen.",["","","","","","","","","der Buchladen -"]],
                ["Min stora bruna häst heter Walter.", "Mein großes braunes Pferd heißt Walter.",["","","","das Pferd -e"]],
                ["Kom alla gamla elever?", "Kamen alle alten Schüler?",["","","","der Schüler -"]],
                ["Nej, men några gamla elever kom faktiskt.", "Nein, aber einige alte Schüler kamen tatsächlich.",[]],
            ],
        }
    },
    {
        path: '/ovningar/adjektiv-komparation',
        name: 'AdjektivKomparation',
        component: Ovningsblad,
        props: {
            grammatik: './grammatik/adjektiv-komparation.vue',
            title: "Komparation",
            avsnitt: "AdjektivKomparation",
            grambok: true,
            synligVid:3,
            svartVid:4,

            uppgifter: [
                ["En Porsche är snabbare än en BMW.", "Ein Porsche ist schneller als ein BMW.",["","der Porsche -s","","","","","der BMW -s"]],
                ["Men min Opel är snabbast.", "Aber mein Opel ist der schnellste.",["","","der Opel -"]],
                ["Tyskland är större än Sverige.", "Deutschland ist größer als Schweden.",[]],
                ["Europas största land är dock Ryssland.", "Das größte Land Europas ist doch Russland.",["","","das Land -er+"]],
                ["Du är min trevligaste väninna.", "Du bist meine netteste Freundin.",["","","","","die Freundin -nen"]],
                ["Hon är mycket yngre än du.", "Sie ist viel jünger als du.",[]],
                ["Nej, hon är precis lika gammal som jag.", "Nein, sie ist genau so alt wie ich.",[]],
                ["Den äldste sonen blev kung.", "Der älteste Sohn wurde König.",["","","","","der König -e"]],
                ["Jag är längre än min bror men kortare än min syster.", "Ich bin länger als mein Bruder, aber kürzer als meine Schwester.",[]],
                ["Finland är kallare än Schweiz, men varmare än Antarktis.", "Finnland ist kälter als die Schweiz, aber wärmer als die Antarktis.",["Finnland","","","","","","","","die Antarktis"]],
                ["Kebnekaise är högt, Mont Blanc högre, men Mount Everest är högst.", "Kebnekaise ist hoch, Mont Blanc ist höher, aber Mount Everest ist am höchsten.",[]],
                ["Svårare kan det väl inte vara?", "Schwieriger kann es doch nicht sein?",[]],
            ],
        }
    },

    {
        path: '/ovningar/none6',
        rubrik: 'Prepositioner',
        synligVid: 2
    },


    {
        path: '/ovningar/prepositioner-som-styr-ackusativ',
        name: 'PrepositionerSomStyrAckusativ',
        component: Ovningsblad,
        props: {
            grammatik: './grammatik/prepositioner-som-styr-ackusativ.vue',
            title: "Prepositioner som styr ackusativ",
            avsnitt: "PrepositionerSomStyrAckusativ",
            grambok: true,
            synligVid:2,
            svartVid:2,

            uppgifter: [
                ["Han kör mot en sten.", "Er fährt gegen einen Stein.",["","","","","der Stein -e"]],
                ["Hon går ingenstans utan sin hund", "Sie geht nirgendwo ohne ihren Hund.",["","","nirgendwo","","","der Hund -e"]],
                ["Vi går genom staden.", "Wir gehen durch die Stadt.",["","","","die Stadt -e+"]],
                ["Vad kan vi göra för honom?", "Was können wir für ihn machen?",[]],
                ["Runt om trädgården står stora träd.", "Rund um den Garten stehen große Bäume.",["", "der Garten -+"]],
                ["Ett liv utan kärlek vore meningslöst.", "Ein Leben ohne Liebe wäre sinnlos.",["","","","Liebe","","sinnlos"]],
                ["Ni ska arbeta för oss, inte mot oss.", "Ihr sollt für uns arbeiten, nicht gegen uns.",[]],
                ["Många tankar far genom huvudet nu.", "Viele Gedanken gehen mir jetzt durch den Kopf.",["","der Gedanke -n","gehen mir","","der Kopf -e+"]],
            ],
        }
    },
    {
        path: '/ovningar/prepositioner-som-styr-dativ',
        name: 'PrepositionerSomStyrDativ',
        component: Ovningsblad,
        props: {
            grammatik: './grammatik/prepositioner-som-styr-dativ.vue',
            title: "Prepositioner som styr dativ",
            avsnitt: "PrepositionerSomStyrDativ",
            grambok: true,
            synligVid:2,
            svartVid:2,

            uppgifter: [
                ["Kom till mig!", "Komm zu mir!",[]],
                ["Hon bor hos sina föräldrar.", "Sie wohnt bei ihren Eltern.",[]],
                ["Sedan ett år tillbaka är jag vegetarian.", "Seit einem Jahr bin ich Vegetarier.",["","","","","","","Vegetarier(in)"]],
                ["Enligt min mening är det en dum idé.", "Meiner Meinung nach ist es eine blöde Idee.",["","","die Meinung -en","","","","","die Idee -n"]],
                ["Med dig har jag alltid roligt.", "Mit dir habe ich immer Spaß.",[]],
                ["Jag har fått en present från mina syskon.", "Ich habe ein Geschenk bekommen, von meinen Geschwistern.",["","","","","das Geschenk -e","","","Geschwister (pl)"]],
                ["Deltagarna kommer från många länder.", "Die Teilnehmer kommen aus vielen Ländern.",["","","","","das Land -er+"]],
                ["Hon kommer precis från skolan.", "Sie kommt gerade von der Schule.",["","","","","die Schule -n"]],
                ["Låt oss åka till IKEA.", "Lasst uns zu IKEA fahren.",[]],
                ["Med din utbildning får du säkert ett bra jobb.", "Mit deiner Ausbildung kriegst du sicher einen guten Job.",["","","die Ausbildung -en","","","","","","der Job -s"]],
                ["Vi bor mittemot stationen.", "Wir wohnen gegenüber dem Bahnhof.",["","","","der Bahnhof -e+"]],
                ["Har någon utom offret sett rånaren?", "Hat jemand außer dem Opfer den Rauber gesehen?",["","","","der Opfer -", "", "der Rauber -"]],
            ],
        }
    },
    {
        path: '/ovningar/prepositioner-som-styr-ackusativ-eller-dativ',
        name: 'PrepositionerSomStyrAckusativEllerDativ',
        component: Ovningsblad,
        props: {
            grammatik: './grammatik/prepositioner-som-styr-ackusativ-eller-dativ.vue',
            title: "Prepositioner som styr ackusativ eller dativ",
            avsnitt: "PrepositionerSomStyrAckusativEllerDativ",
            grambok: true,
            synligVid:2,
            svartVid:2,

            uppgifter: [
                ["Sätt dig bredvid mig!", "Setz dich neben mich!",[]],
                ["Tavlan hänger på väggen.", "Die Tafel hängt an der Wand.",["die Tafel -n", "","", "die Wand -e+"]],
                ["Glaset står på bordet.", "Das Glas steht auf dem Tisch.",["das Glas -er+", "", "", "der Tisch -e"]],
                ["Fåglarna flyger ovanför taken fram och tillbaka.", "Die Vögel fliegen über den Dächern hin und her.",["der Vogel -+", "","", "der Dach -er+","hin und her","hin und her","hin und her"]],
                ["Barnen leker framför sitt hus.", "Die Kinder spielen vor ihrem Haus.",[]],
                ["Hunden sover under bordet.", "Der Hund schläft unter dem Tisch.",["der Hund -e","","", "der Tisch -e"]],
                ["Göm dig bakom trädet. (uppfattas som befintlighet)", "Versteck dich hinter dem Baum.",["sich verstecken","sich verstecken","","der Baum -e+"]],
                ["Häng tavlan på väggen!", "Häng die Tafel an die Wand!",["","die Tafel -n","","die Wand -e+"]],
                ["Hon lägger väskan under sängen.", "Sie legt die Tasche unter das Bett.",["","legen","die Tasche -n","","das Bett -er"]],
                ["Är någon i huset?", "Ist jemand im Haus?",[]],
                ["Åker ni till stan?", "Fahrt ihr in die Stadt?",["","","","die Stadt"]],
                ["Han sitter alltid vid datorn.", "Er sitzt immer am Computer.",["","","","","der Computer -s"]],
                ["Ställ dig framför honom, men bakom mig!", "Stell dich vor ihn, aber hinter mich!",[]],
                ["Mellan bergen ligger en sjö.", "Zwischen den Bergen liegt ein See.",["","der Berg -e","","","der See -n"]],

            ],
        }
    },
    {
        path: '/ovningar/prepositioner-blandade-ovningar',
        name: 'PrepositionerBlandadeOvningar',
        component: Ovningsblad,
        props: {
            grammatik: './grammatik/prepositioner-blandade-ovningar.vue',
            title: "Prepositioner blandade övningar",
            avsnitt: "PrepositionerBlandadeOvningar",
            grambok: false,
            synligVid:2,
            svartVid:2,

            uppgifter: [
                ["I staden bor nästan bara studenter.", "In der Stadt wohnen fast nur Studenten.",["","", "die Stadt -e+"]],
                ["Runt sjön ligger höga berg.", "Um den See liegen hohe Berge.",["","der See -n"]],
                ["I rummet var det helt mörkt.", "Im Zimmer war es ganz dunkel.",["", "das Zimmer -"]],
                ["Vill du inte prata med oss?", "Willst du nicht mit uns reden?",[]],
                ["På denna platsen får du inte sitta.", "Auf diesem Platz darfst du nicht sitzen.",["", "", "der Platz -e+"]],
                ["Men du kan sätta dig på den stolen därborta.", "Aber du kannst dich auf den Stuhl dadrüben setzen.",["","","","","","","","der Stuhl -e+"]],
                ["Jag skall göra allt för dig.", "Ich werde alles für dich tun.",[]],
                ["Utan dig kan jag inte leva.", "Ohne dich kann ich nicht leben.",[]],
                ["I morgon åker vi utomlands.", "Morgen fahren wir ins Ausland.",[]],
                ["Vi stannar länge utomlands.", "Wir bleiben lange im Ausland.",[]],
                ["Efter en vecka gav han upp.", "Nach einer Woche hat er aufgegeben.",["","","die Woche -n"]],
                ["Vi går på kaféet!", "Lasst uns ins Café gehen!",["", "", "", "das Café -s"]],
                ["Nej, jag har inte lust att äta på kaféet.", "Nein, ich habe keine Lust im Café zu essen.",[]],
                ["Jag jobbar på ett kafé.","Ich arbeite in einem Café.",[]],
                ["På det här viset kommer vi tjäna mera pengar.", "Auf dieser Weise werden wir mehr Geld verdienen.",["","","","die Weise -n"]],
                ["Upp ur vattnet, barn!", "Raus aus dem Wasser, Kinder!",["raus", "", "das Wasser"]],
            ],
        }
    },
    {
        path: '/ovningar/none7',
        radbryt: true,
    },

    {
        path: '/ovningar/prepositioner-speciella-verbuttryck',
        name: 'PrepositionerSpeciellaVerbuttryck',
        component: Ovningsblad,
        props: {
            grammatik: './grammatik/prepositioner-speciella-verbuttryck.vue',
            title: "Prepositioner i speciella verbuttryck",
            avsnitt: "PrepositionerSpeciellaVerbuttryck",
            grambok: true,
            synligVid:4,
            svartVid:5,

            uppgifter: [
                ["Jag är sysselsatt med mitt skolarbete.", "Ich bin mit meiner Schularbeit beschäftigt.",[]],
                ["Vi räknar med dig.", "Wir rechnen mit dir.",[]],
                ["Jag längtar efter sommaren.", "Ich sehne mich nach dem Sommer.",["","","","der Sommer -"]],
                ["Det hänger på dig, om det är möjligt.", "Es hängt von dir ab, ob es möglich ist.",[]],
                ["Jag är emot förslaget.", "Ich bin gegen den Vorschlag.",["","","","der Vorschlag -e+"]],
                ["Vi måste avstå från många saker.", "Wir müssen auf viele Sachen verzichten.",[]],
                ["Jag retar mig så på de nya reglerna.", "Ich ärgere mich so über die neuen Regeln.",["","","","","","","","die Regel -n"]],
                ["Jag glädjer mig över vår framgång.", "Ich freue mich über unseren Erfolg.",["","","","","","der Erfolg -e"]],
                ["Jag ser fram emot vårt bröllop.", "Ich freue mich auf unsere Hochzeit.",["","","","","","die Hochzeit -en"]],
                ["Det beror på vädret.", "Es kommt auf das Wetter an.",["","","","das Wetter -"]],
                ["Jag väntar på min syster.", "Ich warte auf meine Schwester.",[]],
                ["Jag är rädd för hundar.", "Ich habe Angst vor Hunden.",["","","","","der Hund -e"]],
                ["Jag tänker alltid bara på dig.", "Ich denke immer nur an dich.",[]],
            ],
        }
    },
    {
        path: '/ovningar/pronominaladverb',
        name: 'Pronominaladverb',
        component: Ovningsblad,
        props: {
            grammatik: './grammatik/pronominaladverb.vue',
            title: "Pronominal-adverb",
            avsnitt: "Pronominaladverb",
            grambok: true,
            synligVid:4,
            svartVid:5,

            uppgifter: [
                ["Vi räknar med att kunna åka hem imorgon.", "Wir rechnen damit, morgen nach Hause fahren zu können.",
                    ["","rechnen mit (+dat)"]],
                ["Jag ser fram emot att ta studenten till sommaren.", "Ich freue mich darauf, diesen Sommer das Abitur zu machen.",
                    ["", "sich freuen auf (+ack) ", "sich freuen auf (+ack) ", "sich freuen auf (+ack) ","","das Abitur machen","das Abitur machen","diesen Sommer","diesen Sommer"]],
                ["Jag litar på att du vet vad du gör.", "Ich verlasse mich darauf, dass du weißt, was du machst.",
                    ["", "sich verlassen auf (+ack)", "sich verlassen auf (+ack)"]],
                ["Det beror på att ingen har löst problemet ännu.", "Es liegt daran, dass noch niemand das Problem gelöst hat.",
                    ["","liegen an (+dat)", "liegen an (+dat)"]],
                ["Är du glad över att du har kommit tillbaka?", "Freust du dich darüber, dass du zurückgekommen bist?",
                    ["", "", "sich freuen über (+ack)" ,"sich freuen über (+ack)", "", "", "", "", ""]],
                ["Vi måste avstå från att köpa ett nytt hus.", "Wir müssen darauf verzichten, ein neues Haus zu kaufen.",["", "", "verzichten auf (+ack)", "verzichten auf (+ack)"]],
                ["Jag tänker på när vi var små.", "Ich denke daran, als wir klein waren.",
                    ["", "denken an (+ack)", "denken an (+ack)"]],
                ["Han väntar på att åka till Frankrike.", "Er wartet darauf, nach Frankreich zu fahren.",
                    ["", "warten auf (+ack)", "warten auf (+ack)", "", "", "", "Frankreich"]],
                ["Jag tvivlar på att vi någonsin kommer att resa till mars.", "Ich zweifle daran, dass wir jemals nach Mars reisen werden.",
                    ["", "zweifeln an (+dat)", "zweifeln an (+dat)", "", "", "jemals", "","","","","Mars"]],
                ["Han envisas med att alltid ha en hatt.", "Er besteht darauf, immer einen Hut zu tragen.",
                    ["", "bestehen auf (+ack)", "bestehen auf (+ack)", "", "", "","", "der Hut -e+"]],
            ],
        }
    },
    {
        path: '/ovningar/none8',
        rubrik: 'Pronomen',
        synligVid: 1
    },

    {
        path: '/ovningar/possessiva-pronomen',
        name: 'PossessivaPronomen',
        component: Ovningsblad,
        props: {
            grammatik: './grammatik/possessiva-pronomen.vue',
            title: "Possessiva pronomen",
            avsnitt: "PossessivaPronomen",
            grambok: true,
            synligVid:1,
            svartVid:1,

            uppgifter: [
                ["Känner du min syster?", "Kennst du meine Schwester?",["","","","die Schwester -"]],
                ["Vårt hus är helt nytt.", "Unser Haus ist ganz neu.",["","das Haus -er+","","",""]],
                ["Deras barn är artiga.", "Ihre Kinder sind höflich.",["","","","höflich"]],
                ["Han älskar sin flickvän.", "Er liebt seine Freundin.",["", "", "","die Freundin -nen"]],
                ["Hon älskar sin pojkvän.", "Sie liebt ihren Freund.",["","","","der Freund -e"]],
                ["Ni måste städa ert rum, barn!", "Ihr müsst euer Zimmer aufräumen, Kinder!",["","","aufräumen"]],
                ["Ni måste städa ert hus, herr Schlappmann!", "Sie müssen Ihr Haus aufräumen, Herr Schlappmann!",["","","aufräumen"]],
                ["Hans hund är liten.", "Sein Hund ist klein.",[]],
                ["Det är ditt val.", "Es ist deine Wahl.",["","","","die Wahl -en"]],
            ],
        }
    },

    {
        path: '/ovningar/relativa-pronomen-nominativ',
        name: 'RelativaPronomenNominativ',
        component: Ovningsblad,
        props: {
            grammatik: './grammatik/relativa-pronomen.vue',
            title: "Relativa pronomen i nominativ",
            avsnitt: "RelativaPronomenNominativ",
            grambok: true,
            synligVid:3,
            svartVid:4,

            uppgifter: [
                ["Känner du kvinnan som bor i Bonn?", "Kennst du die Frau, die in Bonn wohnt?",["","","die Frau -en"]],
                ["Har du en cykel som är blå?", "Hast du ein Fahrrad, das blau ist?",["","","","das Fahrrad -er+"]],
                ["Där bor min bror som är tolv år.", "Da wohnt mein Bruder, der zwölf Jahre ist.",["","","","der Bruder -+"]],
                ["Där står en flicka som har brunt hår.", "Da steht ein Mädchen, das braune Haare hat.",["","","","das Mädchen -","","","","das Haar -e (använd plural)"]],
                ["Där kommer pojkarna som spelar fotboll.", "Da kommen die Jungen, die Fußball spielen.",["", "", "der Junge -n"]],
                ["Hundarna som skäller gillar jag inte.", "Die Hunde, die bellen, mag ich nicht.",["der Hund -e","","bellen"]],
                ["Barnen som kommer från Finland, är bra på matte.", "Die Kinder, die aus Finnland kommen, sind gut in Mathe.",["das Kind -er","","","","","","","in Mathe","in Mathe"]],
                ["Min vän, som jobbar som ingenjör, har studerat länge.", "Mein Freund, der als Ingenieur arbeitet, hat lange studiert.",["","","","","","der Ingenieur -e"]],
                ["Jag har besökt alla länder, som är demokratiska.", "Ich habe alle Länder besucht, die demokratisch sind.",["","","","","das Land -er+"]],

            ],
        }
    },
    {
        path: '/ovningar/relativa-pronomen-alla-kasus',
        name: 'relativaPronomenAllaKasus',
        component: Ovningsblad,
        props: {
            grammatik: './grammatik/relativa-pronomen.vue',
            title: "Relativa pronomen i alla kasus",
            avsnitt: "RelativaPronomenAllaKasus",
            grambok: true,
            synligVid:4,
            svartVid:5,

            uppgifter: [
                ["Är Helmut mannen som du älskar?", "Ist Helmut der Mann, den du liebst?",["","","der Mann -er+"]],
                ["Nej, han är bara en vän, som jag spelar tennis med.", "Nein, er ist nur ein Freund, mit dem ich Tennis spiele.",["", "", "", "", "", "der Freund -e"]],
                ["Har du sett filmen som spelades in i Hamburg?", "Hast du den Film gesehen, der in Hamburg gedreht wurde?",["","","","der Film -e","","drehen (eg.veva)", "drehen (eg.veva)"]],
                ["Nej, men jag sett en film, som handlar om Sophie Scholl.", "Nein, aber ich habe einen Film gesehen, der von Sophie Scholl handelt.",["","","","","","der Film -e","", "handeln von","handeln von"]],
                ["Ser du flickan, som har en blå klänning?", "Siehst du das Mädchen, das ein blaues Kleid trägt?",["","","","","tragen","","","das Kleid -er"]],
                ["Känner du kvinnan, vars lägenhet du hyr?", "Kennst du die Frau, deren Wohnung du mietest?",["", "", "", "", "die Wohnung -en","","mieten"]],
                ["Han har många vänner som han berättar allt [för].", "Er hat viele Freunde, denen er alles erzählt.",[]],
                ["Jag tänker aldrig på dem, som inga pengar har.", "Ich denke nie an die, die kein Geld haben.",[]],
                ["Huset som vi bor i, byggdes på 1800-talet.", "Das Haus, in dem wir wohnen, wurde im 19. Jahrhundert gebaut.",["","","","","","","im 19. Jahrhundert","im 19. Jahrhundert"]],
                ["Äntligen träffade jag henne, som han har berättat så mycket om.", "Endlich traf ich sie, von der er so viel erzählt hat.",[]],
                ["I denna staden bor ingen, som jag känner.", "In dieser Stadt wohnt keiner, den ich kenne.",["","","die Stadt -e+"]],
            ],
        }
    },
    {
        path: '/ovningar/none9',
        rubrik: 'Adverb',
        synligVid: 3
    },
    {
        path: '/ovningar/sehr-viel-viele',
        name: 'sehr-viel-viele',
        component: Ovningsblad,
        props: {
            grammatik: "Testgrammatik",
            title: 'Sehr, viel, viele',
            avsnitt: "SehrVielViele",
            grambok: true,
            synligVid:3,
            svartVid:3,

            uppgifter: [
                ["Har du mycket pengar?", "Hast du viel Geld?",["","","","Geld"]],
                ["Nej, men jag har många barn.", "Nein, aber ich habe viele Kinder.",[]],
                ["Jag är väldigt glad att jag är här.", "Ich bin sehr froh, dass ich hier bin.",[]],
                ["Vi hade väldigt kul igår.", "Wir hatten gestern viel Spaß.",[]],
                ["Denna apparat förbrukar väldigt mycket energi.", "Dieses Gerät verbraucht sehr viel Energie.",
                    ["","das Gerät", "verbrauchen", "", "", "die Energie"]],
                ["Boken var väldigt intressant.", "Das Buch war sehr interessant.",[]],
                ["Hon är väldigt trött.", "Sie ist sehr müde.",[]]
            ],
        }
    },
    {
        path: '/ovningar/none10',
        rubrik: 'Konjunktioner',
        synligVid: 2
    },

    {
        path: '/ovningar/als-wann-wenn',
        name: 'När als/wann/wenn',
        component: Ovningsblad,
        props: {
            grammatik: "Testgrammatik",
            title: 'När\nals/wann/wenn',
            avsnitt: "AlsWannWenn",
            grambok: true,
            synligVid:2,
            svartVid:3,

            uppgifter: [
                ["När kommer ni?", "Wann kommt ihr?",[]],
                ["När jag lagar mat, lyssnar jag på radio.", "Wenn ich koche, höre ich Radio.",[]],
                ["Jag vet inte riktigt, när konserten börjar.", "Ich weiß nicht genau, wann das Konzert anfängt.",["","","","","","das Konzert -e"]],
                ["Det var mörkt, när vi åkte hem i går kväll.", "Es war dunkel, als wir gestern Abend nach Hause fuhren.",["","","dunkel","","","","nach Hause","gestern Abend","gestern Abend","gestern Abend"]],
                ["Det är alltid mörkt, när jag stiger upp tidigt.", "Es ist immer dunkel, wenn ich früh aufstehe.",["","","","dunkel","","","aufstehen","aufstehen","früh"]],
                ["När jag blir 18, skall jag köpa en bil.", "Wenn ich 18 werde, werde ich ein Auto kaufen.",[]],
                ["När jag fyllde 15, fick jag en moped.", "Als ich 15 wurde, bekam ich ein Moped.",["","","","","","","","das Moped -s"]]
            ],
        }
    },
    {
        path: '/ovningar/ob-wenn',
        name: 'Om - ob/wenn',
        component: Ovningsblad,
        props: {
            grammatik: "Testgrammatik",
            title: 'Om - ob/wenn',
            avsnitt: "ObWenn",
            grambok: true,
            synligVid:3,
            svartVid:4,

            uppgifter: [
                ["Om du har lust kan du komma förbi.", "Wenn du Lust hast, kannst du vorbeikommen.",["","","","","","","vorbeikommen","vorbeikommen"]],
                ["Jag vet inte om jag har lust.", "Ich weiß nicht, ob ich Lust habe.",[]],
                ["Om jag har rätt, stannar de inte borta länge.", "Wenn ich Recht habe, bleiben sie nicht lange weg.",["","","","","","","","weg","lange"]],
                ["De kommer om de har tid.", "Sie kommen, wenn sie Zeit haben.",[]],
                ["Vi vet inte säkert om vi har rätt.", "Wir wissen nicht sicher, ob wir Recht haben.",[]],
                ["Om jag jag gillar fotboll? Självklart!", "Ob ich Fußball mag? Selbstverständlich!",["","","","","","selbstverständlich"]],
                ["Om det vore så enkelt, hade man löst problemet för länge sedan.", "Wenn es so einfach wäre, hätte man das Problem schon längst gelöst.",["","","wäre","","einfach","hätte","","","das Problem -e","schon länst","schon länst","schon länst"]],
            ],
        }
    },
    {
        path: '/ovningar/darfor-darfor-att-for-att',
        name: 'DarforDarforAtt',
        component: Ovningsblad,
        props: {
            grammatik: './grammatik/darfor-darfor-att-for-att.vue',
            title: "Därför, därför att, för att",
            avsnitt: "DarforDarforAtt",
            grambok: true,
            synligVid:3,
            svartVid:3,

            uppgifter: [
                ["Jag har köpt en bok, eftersom jag gillar att läsa.", "Ich habe ein Buch gekauft, weil ich lesen mag.",["","","","","das Buch -er+"]],
                ["Jag sover dålig. Därför är jag trött.", "Ich schlafe schlecht. Deshalb bin ich müde.",[]],
                ["Han bor i Berlin för att studera juridik.", "Er wohnt in Berlin, um Jura zu studieren.",["","","","","","","","Jura"]],
                ["Eftersom ingen säger något, gör vi inget.", "Weil niemand etwas sagt, tun wir nichts.",[]],
                ["Jag är trött därför att jag inte kan sova.", "Ich bin müde, weil ich nicht schlafen kann.",[]],
                ["För att kunna skriva behöver man en penna.", "Um schreiben zu können, braucht man einen Stift.",["","","","","","","","der Stift -e"]],
                ["Jag äter för mycket. Därför är jag så fet.", "Ich esse zu viel. Deshalb bin ich so dick.",["","","","","","","","","dick"]],
                ["Vi åker till stan för att gå på bio.", "Wir fahren in die Stadt, um ins Kino zu gehen.",["","","","","","","ins Kino gehen","ins Kino gehen","ins Kino gehen"]],
            ],
        }
    },


    {
        path: '/ovningar/subjunktioner',
        name: 'Subjunktioner',
        component: Ovningsblad,
        props: {
            grammatik: "Testgrammatik",
            title: 'Subjunktioner',
            avsnitt: "Subjunktioner",
            grambok: true,
            synligVid:4,
            svartVid:4,

            uppgifter: [
                ["Han arbetar fastän han är sjuk.", "Er arbeitet, obwohl er krank ist.",[]],
                ["Eftersom det var lördag, var inga elever i skolan.", "Weil es Samstag war, waren keine Schüler in der Schule.",[]],
                ["Vi visste inte att det var så viktigt.", "Wir wussten nicht, dass es so wichtig war.",[]],
                ["Vet ni om vi får komma?", "Wisst ihr, ob wir kommen dürfen?",[]],
                ["Ta med spelet så att vi kan spela!", "Nimm das Spiel mit, damit wir spielen können!",[]],
                ["Det fanns inte många bilar, när jag var liten.", "Es gab nicht viele Autos, als ich klein war.",[]],
                ["Vi övar, för att vi vill bli bättre.", "Wir üben, weil wir besser werden wollen.",["","üben"]],
            ],
        }
    },

    {
        path: '/ovningar/none11',
        rubrik: 'Kasus',
        synligVid: 1
    },



    {
        path: '/ovningar/ackusativobjekt',
        name: 'Ackusativobjekt',
        component: Ovningsblad,
        props: {
            grammatik: "Testgrammatik",
            title: 'Ackusativ-objekt',
            avsnitt: "Ackusativobjekt",
            grambok: true,
            synligVid:1,
            svartVid:1,

            uppgifter: [
                ["Helmut köper ett hus.", "Helmut kauft ein Haus.",["","","","das Haus -er+"]],
                ["Susanne köper en boll.", "Susanne kauft einen Ball.",["","","","der Ball -e+"]],
                ["Kalle är en hund.", "Kalle ist ein Hund.",["","","","der Hund -e"]],
                ["Pelle har en hund.", "Pelle hat einen Hund.",["","","","der Hund -e"]],
                ["Lena har en bror och en syster.", "Lena hat einen Bruder und eine Schwester.",["","","","der Bruder -+","","","die Schwester -n"]],
                ["Ser du trädet?", "Siehst du den Baum?",["","","der Baum -e+"]],
                ["Ser du mig?", "Siehst du mich?",[]],
                ["Jan skriver en bok.", "Jan schreibt ein Buch.",["","","","das Buch -er+"]],
                ["Boken blir antagligen en bästsäljare.", "Das Buch wird wahrscheinlich ein Bestseller.",["", "", "", "", "der Bestseller -"]],
                ["De kan inte höra oss, men vi kan höra dem.", "Sie können uns nicht hören, aber wir können sie hören.",[]],
                ["Har du många vänner?", "Hast du viele Freunde?",["","","","der Freund -e"]],
                ["Jag har bara en vän och en väninna.", "Ich habe nur einen Freund und eine Freundin.",["","","","","der Freund -e","","","die Freundin -nen"]],
                ["Känner du min vän?", "Kennst du meinen Freund?",["","","","der Freund -e"]],
                ["Vi har bara detta förslag. Intresserar det er, barn?", "Wir haben nur diesen Vorschlag. Interessiert er euch, Kinder?",["","","","","der Vorschlag -e+","","","","das Kind -er"]],
            ],
        }
    },
    {
        path: '/ovningar/ackusativ-och-dativobjekt',
        name: 'Ackusativ- och dativobjekt',
        component: Ovningsblad,
        props: {
            grammatik: "Testgrammatik",
            title: 'Ackusativ- och dativobjekt',
            avsnitt: "AckusativOchDativobjekt",
            grambok: true,
            synligVid:2,
            svartVid:2,

            uppgifter: [
                ["Helmut köper en hund åt kvinnan.", "Helmut kauft der Frau einen Hund.",["","","","der Hund -e","","die Frau -en"]],
                ["Lisa ger sin bror en boll.", "Lisa gibt ihrem Bruder einen Ball.",["","","","der Bruder -+","","der Ball -e+"]],
                ["Kalle skänker sin flickvän en present.", "Kalle schenkt seiner Freundin ein Geschenk.",["","schenken","","die Freundin -nen","","das Geschenk -e"]],
                ["Kan du visa mig den nya skolan?", "Kannst du mir die neue Schule zeigen?",["","","","","","","die Schule -n"]],
                ["Räck mig vinet, är du snäll!", "Reich mir den Wein, bitte!",["reichen","","der Wein"]],
                ["Jag köper honom en bil.", "Ich kaufe ihm ein Auto",["","","","","das Auto -s"]],
                ["Hon skriver ett brev till honom.", "Sie schreibt ihm einen Brief.",["","","","der Brief -e"]],
                ["Vi skall ge barnen en tårta i present.", "Wir werden den Kindern als Geschenk eine Torte geben.",["","","","das Kind -er", "","die Tarte -n","","das Geschenk -e"]],
                ["Mina föräldrar skickar pengar till  mig.", "Meine Eltern schicken mir Geld.",["","die Eltern (plur)","","das Geld (sing)","",""]],
                ["De sa aldrig något till oss.", "Sie sagten uns nie was.",[]],
                ["Elevena ger lärarinnan ett äpple.", "Die Schüler geben der Lehrerin einen Apfel.",["der Schüler -","","die Lehrerin -nen","","der Apfel -+"]],
                ["Lärarinnan ger elevena många läxor.", "Die Lehrerin gibt den Schülern viele Hausaufgaben.",["die Lehrerin -nen","","der Schüler -","","die Hausaufgabe -n"]],
                ["Skall jag förklara uppgiften för Er en gång till?", "Soll ich Ihnen nochmal die Aufgabe erklären?",["","","","die Aufgabe -n"]],
                ["Dottern bygger ett hus åt pappan.", "Die Tochter Baut dem Vater ein Haus.",["die Tochter -+", "", "", "das Haus -er+", "", "der Vater -+"]],
                ["Sonen syr en klänning åt mamman.", "Der Sohn näht der Mutter ein Kleid.",["der Sohn -e+", "nähen", "", "das Kleid -er","" ,"die Mutter -+"]],
            ],
        }
    },
    {
        path: '/ovningar/verb-som-styr-dativ',
        name: 'Verb som styr dativ',
        component: Ovningsblad,
        props: {
            grammatik: "Testgrammatik",
            title: 'Verb som styr dativ',
            avsnitt: "VerbSomStyrDativ",
            grambok: true,
            synligVid:4,
            svartVid:5,
            uppgifter: [
                ["Tror du mig verkligen inte?", "Glaubst du mir wirklich nicht?",["","","","wirklich",""]],
                ["Sådant händer alltid mig.", "Sowas passiert mir immer.",[]],
                ["Kan ni hjälpa oss?", "Könnt ihr uns helfen?",[]],
                ["Hon har alltid hjälpt honom.", "Sie hat ihm immer geholfen.",[]],
                ["Tillhör du ett kompisgäng?", "Gehörst du einer Clique?",["","","","die Clique -n"]],
                ["Jag skulle vilja gratulera dig till att du har klarat provet.", "Ich möchte dir dazu gratulieren, dass du die Prüfung bestanden hast.",["","","","","","","","","","bestehen", "die Prüfung -en"]],
                ["Skjortan gillar jag inte, men byxorna passar mig bra.", "Das Hemd gefällt mir nicht, aber die Hose passt mir gut.",["das Hemd -en", "", "", "", "","die Hose -n"]],
                ["Saknar du något?", "Fehlt dir was?",[]],
                ["Ja, jag saknar inspirationen.", "Ja, die Inspiration fehlt mir.",["","","","die Inspiration"]],
                ["Hon har lyckats lösa problemet.", "Es ist ihr gelungen, das Problem zu lösen.",["","","","","das Problem -e"]],
                ["Den historien följer honom hela tiden.", "Diese Geschichte folgt ihm die ganze Zeit.",["","die Geschichte -n"]],            ],
        }
    },


    {
        path: '/ovningar/genitiv',
        name: 'Genitiv',
        component: Ovningsblad,
        props: {
            grammatik: "Testgrammatik",
            title: 'Genitiv',
            avsnitt: "Genitiv",
            grambok: true,
            synligVid:4,
            svartVid:5,

            uppgifter: [
                ["Mannens hatt är svart.", "Der Hut des Mann[e]s ist schwarz.",["der Mann -er+","der Hut -e+"]],
                ["Kvinnans skor är röda.", "Die Schuhe der Frau sind rot.",["die Frau -en","der Schuh -e"]],
                ["Barnets väska är tung.", "Die Tasche des Kindes ist schwer.",["das Kind -er", "die Tasche -n"]],
                ["Barnens skola är ny.", "Die Schule der Kinder ist neu.",[]],
                ["Mick Schumacher sitter i sin pappas bil.", "Mick Schumacher sitzt im Auto seines Vaters.",[]],
                ["Stämmningen på partyt var god.", "Die Stimmung der Party war gut.",["die Stimmung -en","","die Party -s"]],
                ["Min systers pojkvän är en idiot.", "Der Freund meiner Schwester ist ein Idiot.",["","die Schwester -n","der Freund -e","","","der Idiot -en"]],
                ["Fasaden på byggnaden reparerades.", "Die Fassade des Gebäudes wurde repariert.",["die Fassade -n","","das Gebäude -"]],
                ["Jag bor i närheten av stationen.", "Ich wohne in der Nähe des Bahnhofs (vom Bahnhof).",["","","","","","der Bahnhof -er+"]],
                ["Vi står i början av ett massutdöende, sa Greta.", "Wir stehen am Anfang eines Massenaussterbens, sagte Greta.",["","","","","","","das Massenaussterben -"]],
                ["Med hjälp av en dator kunde vi lösa matteproblemet.", "Mit Hilfe eines Computers konnten wir das Matheproblem lösen.",["","","","","der Computer -"]],
                ["Min brors fru kommer från Prag.", "Die Frau meines Bruders kommt aus Prag.",[]],
                ["'Barnets rättigheter' är några av Förenade Nationernas överenskommelser.", "'Die Rechte des Kindes' sind einige der Übereinkommen der Vereinten Nationen.",["","das Recht -e", "", "", "", "", "die Nation -en","das Übereinkommen -"]],
                ["Mina barns fotbollstränare bor i Umeå.", "Der Fußballtrainer meiner Kinder wohnt in Umeå.",["","","der Fußballtrainer -"]],
                ["Min väns idéer är helt galna.", "Die Ideen meines Freunds sind ganz verrückt.",["","","die Idee -n","","","verrückt"]]
            ],
        }
    },
    {
        path: '/ovningar',
        name: 'AllaÖvningar',
        component: AllaOvningar
    },
    {
        path: '/grammatikboken',
        name: 'Grammatikboken',
        component: Grammatikbok
    },



    {
        path: '/grammatikboken/:id',
        name: 'Grammatikboken2',
        component: Grammatikbok
    }
  ]
})
